import { useMemo } from 'react';
import { useFeatureFlagPayload } from 'posthog-js/react';

import { FeatureFlag } from '../../utils/postHog';
import { parseThresholds } from '../utils/disengagement';

/**
 * Reads disengagement thresholds from the `disengagementThresholds` PostHog flag.
 * Falls back per-field to
 * DEFAULT_DISENGAGEMENT_THRESHOLDS when the flag is off or the payload is
 * absent/invalid. Re-renders consumers when the flag payload resolves.
 *
 * `parseThresholds` builds a fresh object, so the result is memoized on the flag payload:
 * consumers use the thresholds as a `useMemo`/`useCallback` dependency, and a new identity
 * on every render would silently invalidate every memo downstream of it.
 */
const useDisengagementThresholds = () => {
  const payload = useFeatureFlagPayload(FeatureFlag.DISENGAGEMENT_THRESHOLDS);
  return useMemo(() => parseThresholds(payload), [payload]);
};

export default useDisengagementThresholds;
